import WarningTriangle from '../../images/warning_triangle_white.png'
import CloseIcon from '../../images/close_icon.png'
import { useTranslation } from 'react-i18next';
import './JobFailedBanner.less';

const JobFailedBanner = ({
    onClickShowDetails = () => {},
    onClickClose = () => {}
}) => {
    const { t } = useTranslation();
    return (
        <div className="job_failed_banner">
            <div className='job_failed_banner_content'>
                <div className='job_failed_warning'>
                    <img className='job_failed_banner_img' src={WarningTriangle} alt={t('Warning')}/>
                    <div className='job_failed_warning_content'>
                        <label>{t('JobHistoryBanner')}</label>
                        <button
                            className='job_details'
                            onClick={(e) => onClickShowDetails(e)}
                            title={t('JobHistoryBanner') + " " + t('JobHistoryBannerDetails')}
                        >
                            {t('JobHistoryBannerDetails')}
                        </button>
                    </div>
                </div>
                <div className='close_button_container'>
                    <button className='close_button' title={t('Close')} onClick={(e) => onClickClose(e)}>
                        <img src={CloseIcon} alt={t('Close')}/>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default JobFailedBanner;